import { INTERNAL_USER_AGENTS, vars } from '@repo/config';

const SYSTEM_LOOKUP_TIMEOUT_MS = 3000;

export interface ISystemUserStats {
  total: number;
  joined: number;
}

interface IInternalUserStatsResponse {
  success: boolean;
  data: ISystemUserStats;
}

interface IFetchUserStatsSystemParams {
  joinedFrom: number;
  joinedUntil: number;
}

export async function fetchUserStatsSystem({
  joinedFrom,
  joinedUntil,
}: IFetchUserStatsSystemParams): Promise<ISystemUserStats | null> {
  const url = new URL('/internal/user-stats', vars.url.identityUrl);
  url.searchParams.set('joinedFrom', String(joinedFrom));
  url.searchParams.set('joinedUntil', String(joinedUntil));

  try {
    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'x-service-api-key': vars.billing.serviceApiKey,
        'user-agent': INTERNAL_USER_AGENTS.authIdentity,
      },
      cache: 'no-store',
      signal: AbortSignal.timeout(SYSTEM_LOOKUP_TIMEOUT_MS),
    });

    if (!response.ok) {
      return null;
    }

    const body = (await response.json()) as IInternalUserStatsResponse;
    return body.data ?? null;
  } catch {
    return null;
  }
}
